module.exports = __webpack_public_path__ + "img/form_null.f4c77025.svg";